<template>
  <main class="card flex-grow-1 ml-6 w-full h-full rounded">
    <PanelTitle :title="panelTitle" />
    <div class="border-box">
      <AddProjectSection
        v-if="addingNewProject"
        @project-added="$emit('project-added')"
        :redcapApiTokens="redcapApiTokens"
        :projects="projects"
      />
      <ManageProjectSection
        v-else
        :project="selectedProject"
        :redcapProjectInfo="selectedRedcapProjectInfo"
        :token="selectedRedcapToken"
        @survey-saved="$emit('survey-saved')"
        @project-unsynced="$emit('project-unsynced')"
        @survey-deleted="$emit('survey-deleted')"
      />
    </div>
  </main>
</template>
<script setup>
import { computed } from "vue"
import PanelTitle from "./PanelTitle.vue"
import AddProjectSection from "./AddProjectSection.vue"
import ManageProjectSection from "./ManageProjectSection.vue"

defineEmits(["project-added", "survey-saved", "survey-deleted", "project-unsynced"])

const props = defineProps({
  addingNewProject: {
    type: Boolean,
    required: true
  },
  selectedProject: {
    type: [Object, null],
    required: true
  },
  redcapApiTokens: {
    type: Array,
    required: true
  },
  selectedRedcapProjectInfo: {
    type: [Object, null],
    required: false,
    default: null
  },
  selectedRedcapToken: {
    type: [Object, null],
    required: false,
    default: null
  },
  projects: {
    type: Array,
    required: true
  }
})

const panelTitle = computed(() => {
  if (props.addingNewProject) {
    return props.addingNewProject.value
      ? "OTLFB Survey Setup"
      : "Import Project"
  }
  return "Manage Project"
})

</script>
